import { useEffect, useState } from 'react';
import { api } from 'services/api';
import { HospitalRecord } from 'types/hospitalRecord';

// `reloadKey` muda quando o cadastro é salvo, para a ficha buscar os dados atualizados.
export function useFetchHospitalRecord(id: string | undefined, reloadKey = 0) {
  const [record, setRecord] = useState<HospitalRecord | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!id) return;

    setLoading(true);
    setError(false);

    api
      .get<HospitalRecord>(`/hospitals/${id}/record`)
      .then(response => setRecord(response.data))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [id, reloadKey]);

  return { record, loading, error };
}
